/** 대표 단가 표시 — 없으면 —, 있으면 천 단위 구분 원화. */
export const formatPrice = (price: number | null): string =>
  price === null ? '—' : `${price.toLocaleString('ko-KR')}원`;
